<div class="navbar-custom">
    <!--
        GPXUSAP-1860: text-only banner shown ONLY while an admin is
        impersonating AND the on-behalf-upload flag is on. No pre-existing
        "impersonation banner area" was found in this template, so this is a
        new, narrowly-gated addition — flag off (the default) or not
        impersonated ⇒ this renders nothing, identical to today.
    -->
    <div
        class="admin-on-behalf-banner"
        *ngIf="impersonate === 'true' && imp.canSubmitWhileImpersonated()"
    >
        You are uploading on behalf of {{ displayName }} as
        {{ imp.adminUser() }}
    </div>
    <div class="container-fluid">
        <ul class="list-unstyled topnav-menu topnav-menu-left m-0">
            <li>
                <button
                    type="button"
                    class="button-menu-mobile waves-effect waves-light"
                    (click)="toggleSidebar()"
                    aria-label="Toggle navigation menu"
                >
                    <i class="ri-menu-line"></i>
                </button>
            </li>
        </ul>
        <ul class="navbar-nav list-unstyled topnav-menu float-end">
            <li class="nav-item quick-add">
                <button
                    type="button"
                    class="quick-add-btn"
                    (click)="toggleQuickMenu($event)"
                    title="Submit Invoice"
                    aria-label="Submit Invoice"
                    [attr.aria-expanded]="quickMenuOpen"
                >
                    <i class="ri-add-line"></i>
                </button>
                <ul
                    class="dropdown-menu dropdown-menu-end quick-add-menu"
                    [class.show]="quickMenuOpen"
                >
                    <li>
                        <a
                            class="dropdown-item"
                            routerLink="/purchase-orders"
                            (click)="quickMenuOpen = false"
                            >PO Based ( Invoice and credit note submission)</a
                        >
                    </li>
                    <li *ngIf="canSubmitLogistics === 'TRUE'">
                        <a
                            class="dropdown-item"
                            routerLink="/submit-logistics-invoice"
                            (click)="quickMenuOpen = false"
                            >Logistics</a
                        >
                    </li>
                    <li *ngIf="canSubmitNonPo === 'TRUE'">
                        <a
                            class="dropdown-item"
                            routerLink="/submit-nonpo-invoice"
                            (click)="quickMenuOpen = false"
                            >Non PO Based</a
                        >
                    </li>
                </ul>
            </li>
            <li class="nav-item dropdown nav-user">
                <ng-container *ngIf="displayName === null">
                    <span
                        class="pro-user-name ms-1 hide dropdown-toggle"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                    >
                        <i class="ri-settings-4-line"></i>
                    </span>
                    <ul class="dropdown-menu">
                        <li>
                            <a
                                class="dropdown-item"
                                routerLink="/vendor-profile"
                            >
                                <i class="ri-user-3-line"></i>
                                <span class="ml-2">Vendor Profile</span>
                            </a>
                        </li>
                        <li *ngIf="impersonate === 'false'">
                            <a
                                class="dropdown-item"
                                routerLink="/change-password"
                            >
                                <i class="ri-lock-2-line"></i>
                                <span class="ml-2">Change Password</span>
                            </a>
                        </li>
                        <li *ngIf="impersonate === 'false'">
                            <a class="dropdown-item" (click)="accountLogout()">
                                <i class="ri-logout-box-line"></i>
                                <span class="ml-2"> Logout</span>
                            </a>
                        </li>
                        <li *ngIf="impersonate === 'true'">
                            <a class="dropdown-item" (click)="accountLogout()">
                                <i class="ri-logout-box-line"></i>
                                <span class="ml-2"> Stop Impersonation</span>
                            </a>
                        </li>
                    </ul>
                </ng-container>

                <ng-container
                    *ngIf="displayName !== null || displayName !== ''"
                >
                    <span
                        class="pro-user-name ms-1 dropdown-toggle"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                    >
                        {{ displayName }}
                    </span>
                    <ul class="dropdown-menu">
                        <li>
                            <a
                                class="dropdown-item"
                                routerLink="/vendor-profile"
                            >
                                <i class="ri-user-3-line"></i>
                                <span class="ml-2">Vendor Profile</span>
                            </a>
                        </li>
                        <li *ngIf="impersonate === 'false'">
                            <a
                                class="dropdown-item"
                                routerLink="/change-password"
                            >
                                <i class="ri-lock-2-line"></i>
                                <span class="ml-2">Change Password</span>
                            </a>
                        </li>

                        <li *ngIf="impersonate === 'true'">
                            <a class="dropdown-item" href="javascript:void(0)">
                                <i class="ri-lock-2-line"></i>
                                <span class="ml-2">Change Password</span>
                            </a>
                        </li>

                        <li *ngIf="impersonate === 'false'">
                            <a class="dropdown-item" (click)="accountLogout()">
                                <i class="ri-logout-box-line"></i>
                                <span class="ml-2"> Logout</span>
                            </a>
                        </li>
                        <li *ngIf="impersonate === 'true'">
                            <a
                                class="dropdown-item"
                                (click)="stopImpersonation()"
                            >
                                <i class="ri-logout-box-line"></i>
                                <span class="ml-2"> Stop Impersonation</span>
                            </a>
                        </li>
                    </ul>
                </ng-container>
            </li>
        </ul>
    </div>
</div>
